import { useEffect, useState } from 'react';
import { CHECKLIST_UNSAVED_MARKS_MESSAGE } from '@/services/checklist/checklistMarking';

/** Resolver os pontos pendentes limpa somente o aviso correspondente. */
export const useChecklistSaveError = (hasUnsavedMarks: boolean) => {
  const [saveError, setSaveError] = useState<string | null>(null);
  useEffect(() => {
    if (!hasUnsavedMarks) {
      setSaveError(current => current === CHECKLIST_UNSAVED_MARKS_MESSAGE ? null : current);
    }
  }, [hasUnsavedMarks]);
  return [saveError, setSaveError] as const;
};
